import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navItems } from '@/config/routes';
import './index.scss';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem('token');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const visibleItems = navItems.filter((item) => !item.auth || isLoggedIn);

  return (
    <nav className="navbar glass-navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <span className="logo-text">阿呆的博客</span>
        </Link>

        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {visibleItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${(location.pathname.includes(item.path) && item.path !== '/') || location.pathname === item.path  ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>

        <div className="nav-toggle" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
